import React from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import Input from "../../form/Input";
import Select from "../../form/Select";

import type { JSX } from "react";
import type { StylesConfig } from "react-select";

import type { FormValues, TemplateOption } from "./CalendarSchedulingModal";
import type { WeekDays } from "../../../utils/fast";

interface DailyTemplateToApplyProps {
  day: WeekDays;
  templatesOptions: TemplateOption[];
  isLoading: boolean;
}

function DailyTemplateToApply({
  day,
  templatesOptions,
  isLoading,
}: DailyTemplateToApplyProps): JSX.Element {
  const { t } = useTranslation("common");
  const { watch } = useFormContext<FormValues>();

  const templateFieldName = `${day}.template`;

  const selectedTemplate = watch(
    templateFieldName as keyof FormValues,
  ) as TemplateOption;

  const customSelectStyles: StylesConfig<TemplateOption> = {
    option: (styles, { data }) => ({
      ...styles,
      color:
        data.isError || data.isEmpty
          ? "var(--status-error)"
          : "var(--foreground)",
    }),
    singleValue: (styles, { data }) => ({
      ...styles,
      color:
        data.isError || data.isEmpty
          ? "var(--status-error)"
          : "var(--foreground)",
    }),
  };

  const templateOptionsDay = templatesOptions.filter(
    (templateOption) => templateOption[day],
  );

  return (
    <div className="bg-muted flex items-center gap-[0.9375rem] rounded-[0.3125rem] p-[0.46875rem] drop-shadow-sm">
      <Input
        className="!mb-0 flex-[0]"
        isReadOnly={selectedTemplate?.isError || selectedTemplate?.isEmpty}
        name={`${day}.active`}
        type="switch"
      />
      <div className="flex-1">{t(day)}</div>
      <Select
        isPortal
        className="bg-card !mb-0 flex-1 rounded-[0.3125rem]"
        isLoading={isLoading}
        isOptionDisabled={(option): boolean => option.isError || option.isEmpty}
        name={templateFieldName}
        options={templateOptionsDay}
        styles={customSelectStyles}
      />
    </div>
  );
}

export default DailyTemplateToApply;
